/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intakeskip1Inputs */

const en_intakeskip1 = /** @type {(inputs: Intakeskip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip — go straight to chat`)
};

const pt_intakeskip1 = /** @type {(inputs: Intakeskip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar — ir direto para o chat`)
};

/**
* | output |
* | --- |
* | "Skip — go straight to chat" |
*
* @param {Intakeskip1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakeskip1 = /** @type {((inputs?: Intakeskip1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakeskip1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakeskip1(inputs)
	return pt_intakeskip1(inputs)
});
export { intakeskip1 as "intakeSkip" }